<template>
  <div class="info">
    <h6 class="info__title">{{ t('profile.info.title') }}</h6>
    <update-form />
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UpdateForm from "@/components/forms/update-form.vue";

const {t} = useI18n();
</script>

<style lang="scss" scoped>
.info {
  &__title {
    color: #F3F3F3;
    font-size: 40px;
    font-weight: 700;
  }
}
</style>